import axios from "../axiosInstance"
import { gerarDadosEnvio } from "../shared/utils/Endpoints"

class DadosEnvioService {
    async obterDadosEnvio() {
        return await axios.get(gerarDadosEnvio, {
            responseType: "blob"
        });
    }
}

export default new DadosEnvioService()